import { ModuleWithProviders } from '@angular/core';
import { CMS_MODULE_OPTIONS } from './cms-module-options.interface';
import { CmsModulePositionComponent } from './components/cms-module-position.component';
import { CmsModulesService } from './services/cms-modules.service';
import { DevConsoleProtocolLogger, injectableProtocolFactory } from '@core/frontend-shared';
import { CMS_PROTOCOL_TOKEN } from './tokens';
import * as i0 from "@angular/core";
import * as i1 from "./services/cms-modules.service";
export let CmsFrontendSharedModule = /*#__PURE__*/(() => {
  class CmsFrontendSharedModule {
    // required to make sure CmsModulesService is created right at app launch
    constructor(service) {}
    static forRoot(options) {
      return {
        ngModule: CmsFrontendSharedModule,
        providers: [{
          provide: CMS_MODULE_OPTIONS,
          useValue: options
        }]
      };
    }
    static {
      this.ɵfac = function CmsFrontendSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CmsFrontendSharedModule)(i0.ɵɵinject(i1.CmsModulesService));
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CmsFrontendSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [injectableProtocolFactory(CMS_PROTOCOL_TOKEN, 'CMS', [DevConsoleProtocolLogger])],
        imports: [CmsModulePositionComponent]
      });
    }
  }
  return CmsFrontendSharedModule;
})();